"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M10.59 9.17 6.12 4.7a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l4.46 4.46zm4.76-4.32 1.19 1.19L4.7 17.88c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L17.96 7.46l1.19 1.19c.31.31.85.09.85-.36V4.5c0-.28-.22-.5-.5-.5h-3.79c-.45 0-.67.54-.36.85m-.52 8.56-1.41 1.41 3.13 3.13-1.2 1.2c-.31.31-.09.85.36.85h3.79c.28 0 .5-.22.5-.5v-3.79c0-.45-.54-.67-.85-.35l-1.19 1.19z"
}), 'ShuffleRounded');